import styles from './index.module.scss';
import FieldAllocationHeader from './components/Header';
import FieldAllocationsLeftPanel from './components/LeftPanel';
import FieldAllocationsRightPanel from './components/RightPanel';
import LiveValidationsDrawer from './components/LiveValidations';
import { useEffect } from 'react';
import { fetchMockRunCapacity, getMockControlsStatus } from './actions/FieldAllocationAction';
import { useDispatch } from 'react-redux';

const FieldAllocations = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchMockRunCapacity());
    dispatch(getMockControlsStatus());
  }, []);

  return (
    <div>
      <FieldAllocationHeader />
      <div className={styles.panelContainer}>
        <FieldAllocationsLeftPanel />
        <FieldAllocationsRightPanel />
      </div>
      <LiveValidationsDrawer />
    </div>
  );
};

export default FieldAllocations;
